"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsSourceMeta = void 0;
var OptionsSourceMeta;
(function (OptionsSourceMeta) {
    let optionsSource;
    (function (optionsSource) {
        optionsSource["ADVERTISER"] = "advertiser";
        optionsSource["CAMPAIGN"] = "campaign";
        optionsSource["LANGUAGES"] = "languages";
        optionsSource["COUNTRIES"] = "countries";
        optionsSource["TWITCH_CATEGORIES"] = "twitchCategories";
        optionsSource["CAMPAIGN_STATES"] = "campaignStates";
        optionsSource["CAMPAIGN_LOST_REASONS"] = "campaignLostReasons";
        optionsSource["ADVERTISER_LOST_REASONS"] = "advertiserLostReasons";
        optionsSource["ADVERTISER_STATES"] = "advertiserStates";
    })(optionsSource = OptionsSourceMeta.optionsSource || (OptionsSourceMeta.optionsSource = {}));
})(OptionsSourceMeta = exports.OptionsSourceMeta || (exports.OptionsSourceMeta = {}));
